import { palette, shape, typography } from "@src/core/styles";
import styled from "styled-components";

export const CardWrapper = styled.div`
  & > div {
    border-radius: ${shape.rounding.XL};
    background-color: ${palette.colors.surface_container};
    box-shadow: 0px 1px 3px 1px rgba(0, 0, 0, 0.15),
      0px 1px 2px 0px rgba(0, 0, 0, 0.3);
  }

  & .MuiCardContent-root {
    padding: 24px;
  }
`;

export const CardTitle = styled.div`
  ${typography.headline_small};
`;

export const CardDescription = styled.div`
  ${typography.body_large_regular};
  padding-top: 8px;
`;
